import { ChangeDetectionStrategy, Component, ElementRef, signal, viewChild } from '@angular/core';
import { PageContainer } from '@app/layout/page-container/page-container';
import { Hero } from './hero/hero';
import { WhyChoose } from './why-choose/why-choose';
import { ExploreThemes } from './explore-themes/explore-themes';
import { MostLoved } from './most-loved/most-loved';
import { Partners } from './partners/partners';
import { Trusted } from './trusted/trusted';
import { PlanTrip } from '@app/shared/plan-trip/plan-trip';

@Component({
  imports: [PageContainer, Hero, WhyChoose, ExploreThemes, MostLoved, Partners, Trusted, PlanTrip],
  selector: 'app-home',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './home.html',
})
export class Home {
  protected readonly showPlanTrip = signal(false);
  private readonly planTripAnchor = viewChild<ElementRef<HTMLElement>>('planTripAnchor');

  // Scrolls to the plan trip anchor when it has actually laid out.
  protected scrollToPlanTrip(): void {
    this.showPlanTrip.set(true);
    this.scrollWhenReady();
  }

  // Scrolls to the plan trip anchor when it has actually laid out.
  private scrollWhenReady(attempts = 0): void {
    const el = this.planTripAnchor()?.nativeElement;
    const ready = el && el.getBoundingClientRect().height > 600;
    if (ready || attempts > 60) {
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    requestAnimationFrame(() => this.scrollWhenReady(attempts + 1));
  }
}
